import css from './steps.module.scss';
import {StepsProps} from './steps.types';

export const Steps = ({current, count}: StepsProps): JSX.Element => {
	return (
		<div className={css.container}>
			<div className={css.imageContainer}>
				<img src="/img/gif-icon.svg" />
			</div>
			<span className={css.counter}>
				{current}/{count}
			</span>
		</div>
	);
};
